export default __webpack_public_path__ + "static/benefit1Img-c0dc668a695bb03c5bafbf9ee24fd912.webp";